import React from 'react'
import Spinner from 'react-bootstrap/esm/Spinner'

function LoadingBackdropBody() {
  return (
    <div className="loading-backdrop-message">
      <Spinner animation="border" role="status" aria-label="Loading" variant="primary" />
    </div>
  )
}

function LoadingBackdrop({
  loading,
  isInTable = true,
// eslint-disable-next-line react/require-default-props
}: { loading: boolean; isInTable?: boolean }) {
  return (
    <>
      {
        isInTable && (
          <caption className="border-0 p-0">
            {loading && <LoadingBackdropBody />}
          </caption>
        )
      }
      {
        !isInTable && (
          <div className="border-0 p-0">
            {loading && <LoadingBackdropBody />}
          </div>
        )
      }
    </>
  )
}
export default LoadingBackdrop

